import { AxiosResponse } from 'axios';
import { withoutAccessHttp } from '../http-common';

export interface ControlTaskReportVerification {
  companyName?: string | null;
  equipmentName?: string | null;
  equipmentCode?: string | null;
  reportNumber?: string | null;
  inspectionDate?: string | null;
  nextInspectionDate?: string | null;
  inspectorName?: string | null;
  reportUrl?: string | null;
  fileName?: string | null;
}

const getReportVerification = (publicId: string): Promise<AxiosResponse<ControlTaskReportVerification>> =>
  withoutAccessHttp.get<ControlTaskReportVerification>(`/control/public/report-verifications/${publicId}`);

const downloadReportPdf = (publicId: string): Promise<AxiosResponse<Blob>> =>
  withoutAccessHttp.get<Blob>(`/control/public/report-verifications/${publicId}/pdf`, {
    responseType: 'blob',
  });

const ReportVerificationService = {
  getReportVerification,
  downloadReportPdf,
};

export default ReportVerificationService;
